import { makeStyles } from '@material-ui/styles';
import React from 'react';


const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minHeight:170,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        backgroundColor: "rgb(243,244,246)",
        borderRadius:'5px',
        margin:'auto 0px',
        marginTop:10,
        padding:'5px 10px',
    },
  
}))

const BoxQuestion = ({ data, indexQuestion}) => {

    const classes = useStyles();

    return ( 
        <>
        <div className={classes['root']}>
            <div className='text-primaryColor'>
                {`پرسش ${indexQuestion+1} `}
            </div>
            <p className="mt-5">
                {
                    data[indexQuestion]
                    ? data[indexQuestion]?.question
                    :''
                }
              
                </p>
        </div>
        </>
     );
}
 
export default BoxQuestion;